import { useState, useEffect } from "react";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";

import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
  useSortable,
  sortableKeyboardCoordinates
} from "@dnd-kit/sortable";

import { CSS } from "@dnd-kit/utilities";


// Composant sortable pour chaque step
function SortableStep({ step }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: step.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: "8px",
    margin: "4px",
    backgroundColor: "#f0f0f0",
    border: "1px solid #ddd",
    listStyle: "none",
  };

  return (
    <li ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {step.title}
    </li>
  );
}

export default function FormTemplateForm({ steps, onSubmit, initialData }) {
  const [title, setTitle] = useState(initialData?.title || "");
  const [description, setDescription] = useState(initialData?.description || "");
  const [selectedSteps, setSelectedSteps] = useState(initialData?.steps || []);

  useEffect(() => {
    if (initialData) {
      setTitle(initialData.title);
      setDescription(initialData.description);
      setSelectedSteps(initialData.steps || []);
    }
  }, [initialData]);

  const toggleStep = (step) => {
    setSelectedSteps((prev) => {
      if (prev.find((s) => s.id === step.id)) {
        return prev.filter((s) => s.id !== step.id);
      }
      return [...prev, step];
    });
  };

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      const oldIndex = selectedSteps.findIndex((s) => s.id === active.id);
      const newIndex = selectedSteps.findIndex((s) => s.id === over.id);
      setSelectedSteps(arrayMove(selectedSteps, oldIndex, newIndex));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ title, description, steps: selectedSteps });
    setTitle("");
    setDescription("");
    setSelectedSteps([]);
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginBottom: "30px" }}>
      <div style={{ marginBottom: "10px" }}>
        <label>Title:</label>
        <input value={title} onChange={(e) => setTitle(e.target.value)} required />
      </div>
      <div style={{ marginBottom: "10px" }}>
        <label>Description:</label>
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} />
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>Steps disponibles:</label>
        <ul style={{ listStyle: "none", padding: 0 }}>
          {steps.map((step) => (
            <li key={step.id}>
              <label>
                <input
                  type="checkbox"
                  checked={!!selectedSteps.find((s) => s.id === step.id)}
                  onChange={() => toggleStep(step)}
                />
                {step.title}
              </label>
            </li>
          ))}
        </ul>
      </div>

      <div style={{ marginBottom: "10px" }}>
        <label>Steps sélectionnés (glisser-déposer pour réordonner):</label>
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext items={selectedSteps.map(s => s.id)} strategy={verticalListSortingStrategy}>
            <ul style={{ padding: 0, border: "1px solid #ccc", minHeight: "50px" }}>
              {selectedSteps.map((step) => (
                <SortableStep key={step.id} step={step} />
              ))}
            </ul>
          </SortableContext>
        </DndContext>
      </div>

      <button type="submit">{initialData ? "Mettre à jour" : "Créer Template"}</button>
    </form>
  );
}
